import React from "react";
import { Table, Select, Menu, Dropdown, Collapse } from "antd";
import Header from "../../../../layout/Header";
import Sidebar from "../../../../layout/Sidebar";
import { message } from "antd";
import moment from "moment";
import copy from "copy-to-clipboard";
import {
  PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS,
  ACTIVE_STATUS_LIST,
  NOT_ACTIVE_STATUS_LIST,
  ALL_STATUS_LIST,
} from "../../../../constants/SelectOptions";
import Bridge from "../../../../constants/Bridge";
import Strings from "../../../../constants/Strings";
import SpeechNote from "../../../../components/common/SpeechNote";
import ViewSpeechAalsFrs from "../../../../components/modal/ViewSpeechAalsFrs";
import Synopsis from "./Synopsis";
import $ from "jquery";

const { Option } = Select;

/** API returns als/controls as 0/1 or "0"/"1" — only active values count.
 *  NOTE: a plain truthiness check is wrong here because the string "0" is
 *  truthy in JS, which would count a control ("0") as ALS and vice-versa. */
const isParticipantFlagSet = (value) =>
  value === true || value === 1 || value === "1";

class List extends React.Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      participants: [],
      loading: false,
      filteredParticipantList: [],
      copyParticipantList: [],
      tableLoading: false,
      selectedStatus: [],
      selectedParticipants: [],
      selectedParticipantsCom: "",
      searchVal: "",
      selectedStatus: [],
      sortBy: "",
      selectedColumns: [],
      activeColumns: [],
      detailsModal: false,
      singleLogDetails: "",
      isStatusModalVisible: false,
      updateStatus: "",
      dropOutInput: "",
      singleParticipant: "",
      dropOutSelected: false,
      singleNoteDetails: "",
      noteModal: false,
      note: "",
      researchBy: "modality.ai",
      researchTypeOptions: [],
      logLoader: false,
      reminderLogData: [],
      toggleReminderModal: false,
      reminderModalLoader: false,
      researchTypes: [],
      reminderParList: [],
      reminderPopup: false,
      reminderType: "",
      copyOfReminderParList: [],
      selectAllStatus: false,
      pagination: 30,
      emailTitle: "",
      emailBody: "",
      formLoading: false,
      selectParticForCustomEmail: [],
      phiStatus: false,
      assignmodal: false,
      assignparticipantid: "",
      assignambassadorlist: [],
      ambassadorlist: [],
      formloader: false,
      filterparticipantdata: [],
      tableloader: false,
      participantType: "all",
      selectedCordinator: [],
      onlyAddress: false,
      isSingleColumn: false,
      columnChecked: false,
      type: "active",
      missing_type: "all",
      isTypeChanged: false,
      totalParticipantCount: 0,
      needtoupgrade: false,
    };
  }
  // simple debounce utility to throttle frequent UI-driven filters
  debounce = (fn, wait = 250) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  debouncedFilter = null;
  // get cooordinator list
  getambassadorlist = () => {
    this.setState({ tableLoading: true });
    Bridge.ambassadors
      .list()
      .then((response) => {
        if (response.status == "1") {
          this.setState({ ambassadorlist: response.data, tableLoading: false });
        }
      })
      .catch((error) => {
        this.setState({ tableLoading: false });
      });
  };

  // get participant list
  getParticipantList = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const paramValue = searchParams.get("filter_status"); // Replace 'paramName' with your parameter name
    this.setState({ tableloader: true, totalParticipantCount: 0 });
    let research_type = this.state.researchBy;
    if (this.state.researchBy != "") {
      let type = this.state.type;
      if (this.state.isTypeChanged == false) {
        if (paramValue === "All") {
          type = "all";
          this.setState({ type: "all" });
        } else if (paramValue === "Withdrawn") {
          type = "not_active";
          this.setState({ type: "not_active" });
        }
      }
      let missing_type = this.state.missing_type;
      let url = `?research_type=${research_type}&type=${type}&missing_type=${missing_type}`;
      Bridge.participants
        .getParticipantList(url)
        .then((response) => {
          if (response.data.status == "1") {
            let count = 0;
            response.data.data.forEach((item, index) => {
              item.selectBoxStatus = "0";
              if (item.last_session) {
                count += 1;
              }
            });
            // console.log("count", count);
            let participantResponse = response.data.data;
            // Normalize dates once, without artificial delay
            const participantData = participantResponse.map((data) => {
              const updated = { ...data };
              if (updated.last_session) {
                const parts = updated.last_session.split("T");
                updated.last_session = moment(parts[0]).format("MM/DD/YYYY");
              }
              if (updated.first_session) {
                const parts2 = updated.first_session.split("T");
                updated.first_session = moment(parts2[0]).format("MM/DD/YYYY");
              }
              if (updated.last_contacted) {
                const stringreplace = updated.last_contacted.split("/");
                if (stringreplace.length === 3) {
                  const last_contacted_date =
                    stringreplace[2] +
                    "-" +
                    stringreplace[1] +
                    "-" +
                    stringreplace[0];
                  updated.last_contacted = moment(last_contacted_date).format(
                    "MM/DD/YYYY"
                  );
                }
              }
              return updated;
            });
            this.setState(
              {
                participants: participantData,
                filteredParticipantList: participantData,
                copyParticipantList: participantData,
                totalParticipantCount: participantData.length,
                searchVal: "",
              },
              () => {
                this.populateFirstnameFilterData(participantData);
                this.setState({ tableloader: false });
                if (paramValue === "Study_Completed") {
                  this.setState(
                    {
                      selectedStatus: ["Study Completed"],
                    },
                    () => this.filter_data()
                  );
                }
              }
            );
          } else if (response.data.status == "4") {
            let list = [
              {
                participants_id: 0,
                relation_to_als: "",
                referred_by: "",
                date_joined: "",
                session_frequency: "monthly",
                participants_accounts_id: 0,
                neurostamp_id: "NSTYDSSSS03",
                modality_id: "dss23sdssdsdwgghgjhjhjkjddddddd",
                eals_id: "",
                research_type: "Radcliff Project",
                consent_status: "Account Created",
                dropped_out_reason: "",
                dropped_out_date: "",
                dropped_out_person: "",
                dropped_out_other_reason: "",
                radcliff_session_type: "Independent",
                date_started_independant_session: "09/13/2023",
                date_created: "2022-10-06T07:54:12.000Z",
                date_updated: "2023-09-14T09:17:53.000Z",
                date_of_birth: "07/07/2023",
                date_of_dignosis: "07/13/2023",
                last_session: "",
                first_session: "",
                total_sessions: 0,
                als: "",
                controls: "",
                shoe_size: "",
                spirometer_id: "9090",
                right_sole_id: "1234",
                left_sole_id: "1234",
                radcliff_session_entry_count: 0,
                self_report_count: 0,
                self_report_first_session_date: "",
                self_report_last_session_date: "",
                session_entry_first_session_date: "",
                session_entry_last_session_date: null,
                radcliff_date_of_diagnosis: "07/13/2023",
                radclff_ethnicity: "White",
                radcliff_date_of_onset: "07/01/2023",
                radcliff_gender: "Male",
                radcliff_date_of_birth: "07/07/2023",
              },
              {
                participants_id: 1,
                relation_to_als: "",
                referred_by: "",
                date_joined: "",
                session_frequency: "monthly",
                participants_accounts_id: 1,
                neurostamp_id: "NSTYDSSSS01",
                modality_id: "dss23sdsfdfgghgjhjhjkjddddddd",
                eals_id: "",
                research_type: "Radcliff Project",
                consent_status: "Account Created",
                dropped_out_reason: "",
                dropped_out_date: "",
                dropped_out_person: "",
                dropped_out_other_reason: "",
                radcliff_session_type: "Independent",
                date_started_independant_session: "09/13/2023",
                date_created: "2022-10-06T07:54:12.000Z",
                date_updated: "2023-09-14T09:17:53.000Z",
                date_of_birth: "07/07/2023",
                date_of_dignosis: "07/13/2023",
                last_session: "",
                first_session: "",
                total_sessions: 0,
                als: "",
                controls: "",
                shoe_size: "",
                spirometer_id: "9090",
                right_sole_id: "1234",
                left_sole_id: "1234",
                radcliff_session_entry_count: 0,
                self_report_count: 0,
                self_report_first_session_date: "",
                self_report_last_session_date: "",
                session_entry_first_session_date: "",
                session_entry_last_session_date: null,
                radcliff_date_of_diagnosis: "07/13/2023",
                radclff_ethnicity: "White",
                radcliff_date_of_onset: "07/01/2023",
                radcliff_gender: "Male",
                radcliff_date_of_birth: "07/07/2023",
              },
            ];
            this.setState({
              tableloader: false,
              totalParticipantCount: response.data.count,
              participants: list,
              needtoupgrade: true,
            });
          } else {
            this.setState({ tableLoading: false });
          }
        })
        .catch((error) => {
          this.setState({ tableLoading: false });
        });
    }
  };
  // filter column by firstname
  populateFirstnameFilterData = (participantData) => {
    const filterparticipantdata = participantData.map((div) => {
      return {
        text: div.participant_name,
        value: div.participant_lname,
      };
    });
    this.setState({ filterparticipantdata });
  };
  // get research type list
  getResearchTypeList() {
    this.setState({ tableLoading: true });
    Bridge.participants
      .getResearchTypeList()
      .then((response) => {
        if (response.data.status == "1") {
          this.setState(
            {
              researchTypes: response.data.data,
              tableLoading: false,
            },
            () => this.getParticipantList()
          );
        }
      })
      .catch((error) => {
        this.setState({ tableLoading: false });
      });
  }
  // on change component function
  componentDidMount() {
    if ($(window).width() < 600) {
      console.log("window::", window);
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    this.debouncedFilter = this.debounce(this.filter_data, 250);
    this.getParticipantList();
    this.getambassadorlist();
    setTimeout(() => {
      this.setState(
        {
          selectedColumns: PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS,
        },
        () => this.setTableColumns(PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS)
      );
    }, 400);
  }
  // on change columns
  handleChangeColumns = (value) => {
    this.setState(
      {
        selectedColumns: value,
      },
      () => this.setTableColumns(value)
    );
  };
  // on change select all input
  onChangeSelectAllInput = (event) => {
    let status = !this.state.selectAllStatus;
    this.setState({ selectAllStatus: status });
    let patientlist = [];
    if (status == true) {
      let participantdata = this.state.participants;
      for (let data of participantdata) {
        data.selectBoxStatus = "1";
        patientlist.push(data);
      }
      this.setState({ participants: patientlist });
    } else if (status == false) {
      let participantdata = this.state.participants;
      for (let data of participantdata) {
        data.selectBoxStatus = "0";
        patientlist.push(data);
      }
      this.setState({ participants: patientlist });
    }
    let inner = [];
    let selected = [];
    let ccopyOfReminderParList = [];
    for (let data of patientlist) {
      if (data.selectBoxStatus == "1") {
        inner = [...inner, data.modality_id];
        if (data.consent_status != "Dropped Out") {
          selected = [...selected, data.participants_accounts_id];
        }
        ccopyOfReminderParList = [
          ...ccopyOfReminderParList,
          data.participants_accounts_id,
        ];
      }
    }

    let commas = inner.join(",");

    this.setState({
      selectedParticipants: inner,
      selectedParticipantsCom: commas,
      selectedParticipantToSend: selected,
      reminderParList: selected,
      copyOfReminderParList: ccopyOfReminderParList,
    });
  };
  // set table columns
  setTableColumns = (options) => {
    let columnsArr = [];

    columnsArr = [...columnsArr];

    let i = 0;
    for (let columnOption of options) {
      let obj = {};

      if (columnOption == "First Session Date") {
        obj = {
          title: "First Session Date",
          dataIndex: "firstSessionDate",
          key: "firstSessionDate",
          width: 150,
          columOrder: 12,
          render: (item) => {
            let first_session_date = item.first_session;
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  {first_session_date ? first_session_date : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      // modality id
      if (columnOption == "Modality Id") {
        obj = {
          title: "Modality Id",
          dataIndex: "modalityId",
          key: "modalityId",
          width: 180,
          columOrder: 7,
          render: (item) => {
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  {item.modality_id ? item.modality_id : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      // neurostamp id
      if (columnOption == "Neurostamp Id") {
        obj = {
          title: "Neurostamp Id",
          dataIndex: "neurostampId",
          key: "neurostampId",
          width: 155,
          columOrder: 8,
          fixed: window.innerWidth > 650 ? "left" : false,
          render: (item) => {
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data d-flex">
                  {item.neurostamp_id ? item.neurostamp_id : "---"}
                  {isParticipantFlagSet(item.controls) &&
                  isParticipantFlagSet(item.als) ? (
                    <div className="participant-icon ml-2">ALS</div>
                  ) : (
                    <>
                      {isParticipantFlagSet(item.controls) && (
                        <div className="participant-icon ml-2">C</div>
                      )}
                      {isParticipantFlagSet(item.als) && (
                        <div className="participant-icon ml-2">ALS</div>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      // Ambassador Name
      if (columnOption == "Coordinator Name") {
        obj = {
          title: "Coordinator Name",
          dataIndex: "ambaserder_name",
          key: "ambaserder_name",
          width: 150,
          columOrder: 9,
          render: (item) => {
            return (
              <div>
                <div
                  className={
                    item.selectBoxStatus && item.selectBoxStatus == "1"
                      ? "grey-div"
                      : ""
                  }
                ></div>
                <div className="table-data">
                  {item.assigned_to ? item.assigned_to : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      // Relation To ALS
      if (columnOption == "Relation To ALS") {
        obj = {
          title: "Relation To ALS",
          dataIndex: "relation_to_als",
          key: "relation_to_als",
          width: 150,
          columOrder: 16,
          render: (item) => {
            return (
              <div>
                <div
                  className={
                    item.selectBoxStatus && item.selectBoxStatus == "1"
                      ? "grey-div"
                      : ""
                  }
                ></div>
                <div className="table-data">
                  {item.relation_to_als ? item.relation_to_als : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }

      if (columnOption == "Last Contacted") {
        obj = {
          title: "Last Contacted",
          dataIndex: "lastContacted",
          key: "lastContacted",
          width: 130,
          columOrder: 10,
          render: (item) => {
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  {item.last_contacted ? item.last_contacted : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }

      if (columnOption == "Last Contacted By") {
        obj = {
          title: "Last Contacted By",
          dataIndex: "lastContactedBy",
          key: "lastContactedBy",
          width: 160,
          columOrder: 11,
          render: (item) => {
            return (
              <div>
                <div
                  className={
                    item.selectBoxStatus && item.selectBoxStatus == "1"
                      ? "grey-div"
                      : ""
                  }
                ></div>
                <div className="table-data">
                  {item.last_contacted_name ? item.last_contacted_name : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }

      if (columnOption == "No Of Sessions") {
        obj = {
          title: "No Of Sessions",
          dataIndex: "noOfSessions",
          key: "noOfSessions",
          columOrder: 15,
          width: 120,
          render: (item) => {
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  {item.total_sessions ? item.total_sessions : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }

      if (columnOption == "Last Session Date") {
        obj = {
          title: "Last Session Date",
          dataIndex: "lastSessionDate",
          key: "lastSessionDate",
          width: 140,
          columOrder: 16,
          fixed: window.innerWidth > 650 ? "right" : false,
          render: (item) => {
            let last_session_date = item.last_session;
            let colorValue = "#fff";
            let dateBefore4Week = moment()
              .subtract(4, "weeks")
              .format("YYYY-MM-DD");
            let dateBefore8Week = moment()
              .subtract(8, "weeks")
              .format("YYYY-MM-DD");
            let current_date = moment().format("YYYY-MM-DD");
            let last_session = moment(last_session_date).format("YYYY-MM-DD");
            if (last_session_date) {
              if (
                last_session <= current_date &&
                last_session >= dateBefore4Week
              ) {
                colorValue = "#adf7b6";
              } else if (
                last_session <= dateBefore4Week &&
                last_session >= dateBefore8Week
              ) {
                colorValue = "#ffee93";
              } else {
                colorValue = "#ffc09f";
              }
            } else {
              colorValue = "#fff";
            }
            return (
              <div>
                <div
                  style={{
                    background: colorValue,
                    cursor: "pointer",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 1,
                    padding: "16px 12px",
                    color: "#000",
                  }}
                >
                  {last_session_date ? last_session_date : "---"}
                </div>
                <div className="table-data">
                  {last_session_date ? last_session_date : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }

      if (columnOption == "Gender") {
        obj = {
          title: "Gender",
          dataIndex: "gender",
          key: "gender",
          columOrder: 15,
          width: 120,
          render: (item) => {
            let gender = "";
            if (item.gender == "1") {
              gender = "Male";
            } else if (item.gender == "2") {
              gender = "Female";
            }
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">{gender ? gender : "---"}</div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "Date of Diagnosis") {
        obj = {
          title: "Date of Diagnosis",
          dataIndex: "date_of_diagnosis",
          key: "date_of_diagnosis",
          columOrder: 15,
          width: 120,
          render: (item) => {
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  {item.date_of_diagnosis
                    ? moment(item.date_of_diagnosis).format("MM/DD/YYYY")
                    : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "Date of Onset") {
        obj = {
          title: "Date of Onset",
          dataIndex: "date_of_onset",
          key: "date_of_onset",
          columOrder: 15,
          width: 120,
          render: (item) => {
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  {item.date_of_symptom_onset
                    ? moment(item.date_of_symptom_onset).format("MM/DD/YYYY")
                    : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "Age") {
        obj = {
          title: "Age",
          dataIndex: "age",
          key: "age",
          columOrder: 15,
          width: 120,
          render: (item) => {
            let age = "";
            if (item.mgh_dob) {
              let date_of_birth = moment(item.mgh_dob).format("YYYY-MM-DD");
              let calculateAge = this.calculateAge(date_of_birth);
              age = calculateAge;
            }
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">{age ? age : "---"}</div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "Ethincity") {
        obj = {
          title: "Ethincity",
          dataIndex: "ethincity",
          key: "ethincity",
          columOrder: 15,
          width: 120,
          render: (item) => {
            let ethnicity = "";
            if (item.ethnicity == "1") {
              ethnicity = "Of Hispanic, Latino/a or Spanish origin";
            } else if (item.ethnicity == "2") {
              ethnicity = "Not of Hispanic, Latino/a or Spanish origin";
            } else if (item.ethnicity == "3") {
              ethnicity = "Prefer not to answer";
            }
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">{ethnicity}</div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "Latest ALSFRS-R Score") {
        obj = {
          title: "Latest ALSFRS-R Score",
          dataIndex: "latest_alsfrs_score",
          key: "latest_alsfrs_score",
          columOrder: 15,
          width: 120,
          render: (item) => {
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  {item.latest_alsfrs_score ? item.latest_alsfrs_score : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }

      if (columnOption == "Status") {
        obj = {
          title: "Status",
          dataIndex: "status",
          key: "status",
          width: 120,
          columOrder: 16,
          fixed: window.innerWidth > 650 ? "right" : false,
          render: (item) => {
            let data = "";
            if (item.consent_status != "" && item.consent_status == "Signed") {
              data = (
                <td
                  className="status-div"
                  style={{ backgroundColor: "#b6d7a8" }}
                >
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (
              item.consent_status != "" &&
              item.consent_status == "E consent sent"
            ) {
              data = (
                <td className="status-div" style={{ background: "#ffe599" }}>
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (
              item.consent_status != "" &&
              item.consent_status == "Dropped Out"
            ) {
              data = (
                <td
                  className="status-div text-white"
                  style={{ background: "#ff0000" }}
                >
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (
              item.consent_status != "" &&
              item.consent_status == "Study Completed"
            ) {
              data = (
                <td
                  className="status-div"
                  style={{ background: "rgb(194 166 247)" }}
                >
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (item.consent_status == "New") {
              data = (
                <td
                  className="status-div text-white"
                  style={{ background: "#8863dd" }}
                >
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (item.consent_status == "Account Created") {
              data = (
                <td
                  className="status-div text-white"
                  style={{ background: "#01a3b7" }}
                >
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (item.consent_status == "Cancel") {
              data = (
                <td className="status-div text-white cancel-color">
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (item.consent_status == "Active") {
              data = (
                <td className="status-div text-white active-status-color">
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (item.consent_status == "") {
              data = (
                <td className="status-div" style={{ background: "#fff" }}>
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            }

            return <div>{data}</div>;
          },
        };
        columnsArr = [...columnsArr, obj];
      }

      if (columnOption == "Date Joined") {
        obj = {
          title: "Date Joined",
          dataIndex: "dateJoined",
          key: "dateJoined",
          width: 130,
          columOrder: 14,
          render: (item) => {
            return (
              <div>
                <div
                  className={
                    item.selectBoxStatus && item.selectBoxStatus == "1"
                      ? "grey-div"
                      : ""
                  }
                ></div>
                <div className="table-data">
                  {item.date_joined ? item.date_joined : "---"}
                </div>
              </div>
            );
          },
          sorter: (a, b) =>
            a.action.date_joined &&
            moment(a.action.date_joined)
              .format("YYYY-MM-DD")
              .localeCompare(moment(b.action.date_joined).format("YYYY-MM-DD")),
          multiple: 3,
        };
        columnsArr = [...columnsArr, obj];
      }
      i++;
    }
    let actionobj = {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 70,
      maxWidth: 70,
      columOrder: 17,
      fixed: window.innerWidth > 650 ? "right" : false,
      render: (item) => {
        const menu = (
          <Menu className="action-menu participant-action-menu">
            {/* <Menu.Item key={`show_mdh_data${item.key}`}>
              <a
                className="action-buttons"
                href="#!"
                onClick={() => this.showMGHData(item.neurostamp_id)}
              >
                <i
                  className="fas fa-file-alt"
                  style={{ color: "#000", fontSize: 18 }}
                ></i>
                <span style={{ fontSize: 14, marginLeft: 10 }}>
                  View Demographics
                </span>
              </a>
            </Menu.Item> */}
            <Menu.Item key={`open_patient_portal_${item.key}`}>
              <a
                className="action-buttons"
                onClick={() => this.openPatientPortal(item)}
                href="#!"
              >
                <i
                  className="fas fa-file-alt"
                  style={{ color: "#000", fontSize: 18 }}
                ></i>
                <span style={{ fontSize: 14, marginLeft: 10 }}>
                  Open Patient Portal
                </span>
              </a>
            </Menu.Item>
            <Menu.Item key={`view_alsfrs_${item.key}`}>
              <ViewSpeechAalsFrs item={item} />
            </Menu.Item>
          </Menu>
        );

        return (
          <div style={{ width: "100%" }}>
            <Dropdown overlay={menu}>
              <a
                className="ant-dropdown-link action-link"
                onClick={(e) => e.preventDefault()}
              >
                <i className="fas fa-ellipsis-v"></i>
              </a>
            </Dropdown>
          </div>
        );
      },
    };
    columnsArr = [...columnsArr, actionobj];
    columnsArr.sort((a, b) => {
      return a.columOrder - b.columOrder;
    });

    this.setState({ activeColumns: columnsArr });
  };
  calculateAge = (birthday) => {
    const today = new Date();
    const birthDate = new Date(birthday);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };
  // show profile details page
  show_profile_details = (params) => {
    params = JSON.stringify(params);
    localStorage.setItem("profile_details", params);
    window.location.assign("/profile-details");
  };
  /// copy email phone data
  copydata = (text) => {
    copy(text, {
      debug: true,
      message: "Link is copied",
    });
    message.success("Copied to clipboard.");
  };
  // show zephyrx details page
  show_zephyrx_data = (item) => {
    let neurostamp_id = item.neurostamp_id;
    let name = item.participant_name + " " + item.participant_lname;
    localStorage.setItem("neurostamp_id", neurostamp_id);
    localStorage.setItem("participant_name", name);
    window.open("/participant/zephyrx-data", "_blank");
  }; // show aural data
  show_aural_data = (item) => {
    let neurostamp_id = item.neurostamp_id;
    let name = item.participant_name + " " + item.participant_lname;

    localStorage.setItem("neurostamp_id", neurostamp_id);
    localStorage.setItem("participant_name", name);
    window.open("/participants/aural", "_blank");
  };
  // reload paticipants
  reloadParticipants = () => {
    this.getParticipantList();
  };
  // show assign modal
  showassignammodal = (item) => {
    let assignedto = "";
    let arr = [];
    if (item.assigned_to) {
      let text = item.assigned_to;
      const myArray = text.split(",");
      for (let d of this.state.ambassadorlist) {
        if (myArray.includes(d.student_name)) {
          arr = [...arr, d.students_id];
        }
      }
    }
    this.setState({
      assignmodal: true,
      assignparticipantid: item.participants_id,
      assignambassadorlist: arr,
    });
  };
  // hide assign modal
  hideassignmodal = () => {
    this.setState({
      assignmodal: false,
    });
  };
  // on select amabassador
  handleSelectAm = (value) => {
    this.setState({ assignambassadorlist: value });
  };
  // assign ambassador
  assignambassor = () => {
    if (this.state.assignambassadorlist.lenth == 0) {
      message.warning("Please select the Coordinator first.");
      return;
    }
    let params = {
      participants_id: this.state.assignparticipantid,
      students: JSON.stringify(this.state.assignambassadorlist),
    };
    this.setState({ formloader: true });
    Bridge.ambassadors
      .assignambassador(params)
      .then((response) => {
        if (response.status == "1") {
          message.success(response.message);
          this.setState(
            {
              assignmodal: false,
              participants_id: "",
              students: [],
              formloader: false,
            },
            () => this.getParticipantList()
          );
        }
      })
      .catch((error) => {});
  };
  // OPEN PATIENT PORTAL
  openPatientPortal = (item) => {
    let modality_id = item.modality_id;
    let url = `?modality_id=${modality_id}&participants_id=${item.participants_id}`;
    Bridge.participants
      .openPatientPortal(url)
      .then((result) => {
        if (result.status == "1") {
          window.open(result.url, "_blank");
        } else {
          message.warn(result.message);
        }
      })
      .catch(function (error) {
        message.error("Please try again!!");
      });
  };
  //open custom email modal
  openCustomEmailModal = (item) => {
    this.setState({
      customModalStatus: true,
      formLoading: false,
      selectedParticipantToSend: item.participants_accounts_id,
      emailTitle: "",
      emailBody: "",
    });
  };
  // show remidner modal
  handleShowReminderPopup = (item) => {
    let arr = [item.participants_accounts_id];
    this.setState({
      reminderParList: arr,
      reminderPopup: true,
      reminderType: "1",
    });
  };
  // hide remidner modal
  handleCancelReminder = () => {
    this.setState({
      reminderPopup: false,
    });
  };
  // on ok remidner modal
  handleOkReminder = () => {
    this.sendNotificationToParti();
  };
  // send notification to participant
  sendNotificationToParti = () => {
    let params = {
      participants_array: JSON.stringify(this.state.reminderParList),
      time_sent:
        new Intl.DateTimeFormat("en-US", {
          dateStyle: "full",
          timeStyle: "long",
        }).format(new Date()) +
        " " +
        Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    if (this.state.reminderParList.length == "0") {
      message.warning("Please select valid participant(s) first.");
      this.setState({ tableLoading: false });
      return;
    }
    this.setState({ tableLoading: true });
    Bridge.participants
      .sendReminder(params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState({
            tableLoading: false,
            reminderPopup: false,
          });
        } else {
          message.warning(response.data.message);
          this.setState({ tableLoading: false, reminderPopup: false });
        }
      })
      .catch(function (error) {
        this.setState({ tableLoading: false });
      });
  };
  // filter by status
  filterStatus = (value) => {
    let searchText = this.state.searchVal;
    this.setState(
      {
        selectedStatus: value,
      },
      () => this.filter_data()
    );
  };
  // shpw mgh data
  showMGHData = (param) => {
    localStorage.setItem("neurostamp_id", param);
    setTimeout(() => {
      window.open("/view-demographics", "_blank");
    }, 1000);
  };
  // on change sort by
  handleSortChange = (value) => {
    this.setState(
      {
        sortBy: value,
      },
      () => this.filter_data()
    );
  };
  /// change date format
  changeDateFormat = (arr) => {
    let newArr = [];
    for (let data of arr) {
      if (data.last_contacted != null) {
        let string = data.last_contacted;
        let search = "-";
        let replaceWith = "/";
        let result = string
          .split(search)
          .reverse()
          .join(replaceWith)
          .toString();
        data.last_contacted = result;
      }
      newArr.push(data);
    }
    return newArr;
  };
  // show details modal
  showDetailsModal = (item) => {
    this.setState({ detailsModal: true });
    this.getNotesForParticipant(item);
  };
  // hide details modal
  hideDetailsModal = () => {
    this.setState({ detailsModal: false });
  };
  // on ok status modal
  handleStatusOk = () => {
    this.setState({
      isStatusModalVisible: false,
      updateStatus: "",
    });
    this.pleaseUpdateStatus();
  };
  // hide status modal
  handleStatusCancel = () => {
    this.setState({
      isStatusModalVisible: false,
      updateStatus: "",
    });
  };
  // on change drop out status
  handleChange = (value) => {
    this.setState({ updateStatus: value });
    if (value == "Dropped Out") {
      this.setState({ dropOutSelected: true });
    } else {
      this.setState({ dropOutSelected: false });
    }
  };
  // on change dropped out status
  handleChangeDropOut = (value) => {
    this.setState({ dropOutInput: value });
  };
  // show status modal
  showStatusModal = (item) => {
    this.setState({
      isStatusModalVisible: true,
      updateStatus: item.consent_status,
      singleParticipant: item,
    });
  };
  // update status
  pleaseUpdateStatus = () => {
    let params = {
      consent_status: this.state.updateStatus,
      participants_id: this.state.singleParticipant.participants_id,
    };
    Bridge.participants
      .updateStatus(params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
        } else {
          message.error(response.data.message);
        }
        this.getParticipantList();
      })
      .catch(function (error) {
        message.error("Please try again!!");
      });
  };
  // on change research type
  handleChangeResearchType = (value) => {
    this.setState({ researchBy: value }, () => this.getParticipantList());
  };
  // select participant to viw reports
  selectedReportsToView = () => {
    if (this.state.selectedParticipantsCom == "") {
      message.warn("Please select participant(s) first.");
      return;
    }
    localStorage.setItem("aparticipants", this.state.selectedParticipantsCom);
    window.open("/participants/view_reports", "_blank");
  };
  // hide reminder modal
  handleCancelReminderModal = () => {
    this.setState({ toggleReminderModal: false });
  };
  // open moda of send reminder
  openModalToSendNot = () => {
    this.setState({ reminderPopup: true });
  };
  // on change table pagination
  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      pagination: pagination.pageSize,
    });
  };
  // close custom email modal
  closeCustomEmailModal = () => {
    this.setState({
      customModalStatus: false,
    });
  };
  // on change participant type
  handleChangeParticipantType = (value) => {
    this.setState(
      {
        participantType: value,
      },
      () => this.filter_data()
    );
  };

  filter_data = () => {
    let searchArray = [];
    let searchInput = this.state.searchVal;
    if (searchInput) {
      for (let d of this.state.copyParticipantList) {
        if (
          (d.modality_id &&
            d.modality_id.toLowerCase().includes(searchInput.toLowerCase())) ||
          (d.neurostamp_id &&
            d.neurostamp_id
              .toLowerCase()
              .includes(searchInput.toLowerCase())) ||
          (d.research_type &&
            d.research_type
              .toLowerCase()
              .includes(searchInput.toLowerCase())) ||
          (d.relation_to_als &&
            d.relation_to_als
              .toLowerCase()
              .includes(searchInput.toLowerCase())) ||
          (d.consent_status &&
            d.consent_status
              .toLowerCase()
              .includes(searchInput.toLowerCase())) ||
          (d.first_session &&
            d.first_session.includes(searchInput.toLowerCase())) ||
          (d.last_session &&
            d.last_session.includes(searchInput.toLowerCase())) ||
          (d.last_contacted &&
            d.last_contacted.includes(searchInput.toLowerCase())) ||
          (d.date_joined &&
            d.date_joined.includes(searchInput.toLowerCase())) ||
          (d.modality_id &&
            d.modality_id.toLowerCase().includes(searchInput.toLowerCase())) ||
          (d.last_contacted_name &&
            d.last_contacted_name
              .toLowerCase()
              .includes(searchInput.toLowerCase())) ||
          (d.assigned_to &&
            d.assigned_to.toLowerCase().includes(searchInput.toLowerCase()))
        ) {
          searchArray.push(d);
        }
      }
    } else {
      searchArray = this.state.copyParticipantList;
    }
    // console.log("searchArray", searchArray);
    //filter by status
    let statusArray = [];
    if (this.state.selectedStatus.length > 0) {
      for (let item of searchArray) {
        if (this.state.selectedStatus.includes(item.consent_status)) {
          statusArray.push(item);
        }
      }
    } else {
      statusArray = searchArray;
    }
    //filter by participant type
    // console.log("statusArray", statusArray);
    let participantTypeArr = [];
    if (this.state.participantType.length > 0 && statusArray.length > 0) {
      for (let item of statusArray) {
        const isAls = isParticipantFlagSet(item.als);
        const isControl = isParticipantFlagSet(item.controls);
        if (this.state.participantType == "als" && isAls) {
          participantTypeArr.push(item);
        } else if (this.state.participantType == "controls" && isControl) {
          participantTypeArr.push(item);
        } else if (this.state.participantType == "all") {
          participantTypeArr.push(item);
        }
      }
    } else {
      participantTypeArr = statusArray;
    }

    // sort by filter
    let sortByArray = [];
    if (this.state.sortBy) {
      let newArr = [];
      for (let data of participantTypeArr) {
        newArr.push(data);
      }
      let text = [];
      if (this.state.sortBy == "LastContactedAsc") {
        text = participantTypeArr
          .sort(
            (a, b) => new Date(b.last_contacted) - new Date(a.last_contacted)
          )
          .reverse();
        sortByArray = text;
      } else if (this.state.sortBy == "LastContactedDesc") {
        text = participantTypeArr.sort(
          (a, b) => new Date(b.last_contacted) - new Date(a.last_contacted)
        );
        sortByArray = text;
      } else if (this.state.sortBy == "LastActiveAsc") {
        text = participantTypeArr
          .sort((a, b) => new Date(b.last_session) - new Date(a.last_session))
          .reverse();
        for (let data of text) {
          if (data.last_session) {
            let newdate = moment(data.last_session).format("MM/DD/YYYY");
            data.last_session = newdate;
          }
        }
        sortByArray = text;
      } else if (this.state.sortBy == "LastActiveDesc") {
        text = participantTypeArr.sort(
          (a, b) => new Date(b.last_session) - new Date(a.last_session)
        );
        for (let data of text) {
          if (data.last_session) {
            let newdate = moment(data.last_session).format("MM/DD/YYYY");
            data.last_session = newdate;
          }
        }
        sortByArray = text;
      } else if (this.state.sortBy == "") {
        sortByArray = participantTypeArr;
      }
    } else {
      sortByArray = participantTypeArr;
    }

    // address
    let addressArr = [];
    if (this.state.selectedColumns.length == 1) {
      if (this.state.selectedColumns.includes("Address")) {
        // console.log("only address");
        // console.log("PARTICIPANT_ACTIVITY_COLUMNS", this.state.selectedColumns);
        for (let data of sortByArray) {
          if (
            data.address &&
            data.address.toLowerCase().includes(searchInput.toLowerCase())
          ) {
            addressArr.push(data);
          }
        }
      }
    } else {
      addressArr = sortByArray;
    }

    this.setState({
      participants: addressArr,
      totalParticipantCount: addressArr.length,
    });
  };

  // on search
  onSearch = (value) => {};
  // on change participant type
  handleChangeType = (value) => {
    this.setState(
      {
        type: value,
        selectedStatus: [],
        searchVal: "",
        sortBy: "",
        participantType: "all",
        missing_type: "all",
        columnChecked: false,
        isTypeChanged: true,
      },
      () => {
        this.getParticipantList();
        if (this.state.columnChecked == true) {
          this.setTableColumns([]);
          this.setState({
            isSingleColumn: true,
            selectedColumns: [],
          });
        } else {
          if (localStorage.getItem("PHIStatus") == "true") {
            this.setState(
              {
                selectedColumns: PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS,
                isSingleColumn: false,
              },
              () =>
                this.setTableColumns(
                  PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS
                )
            );
          } else {
            this.setState(
              {
                selectedColumns: PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS,
                isSingleColumn: false,
              },
              () =>
                this.setTableColumns(
                  PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS
                )
            );
          }
        }
      }
    );
  };
  onChangeColumns = (event) => {
    this.setState(
      {
        columnChecked: event.target.checked,
      },
      () => {
        if (event.target.checked == true) {
          this.setTableColumns([]);
          this.setState({
            isSingleColumn: true,
            selectedColumns: [],
          });
        } else {
          if (localStorage.getItem("PHIStatus") == "true") {
            this.setState(
              {
                selectedColumns: PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS,
                isSingleColumn: false,
              },
              () =>
                this.setTableColumns(
                  PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS
                )
            );
          } else {
            this.setState(
              {
                selectedColumns: PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS,
                isSingleColumn: false,
              },
              () =>
                this.setTableColumns(
                  PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS
                )
            );
          }
        }
      }
    );
  };
  onChangeTab = (key) => {
    console.log(key);
  };

  render() {
    // data source
    const dataSource =
      this.state.participants &&
      this.state.participants.map((item, index) => {
        return {
          key: index,
          checkbox: item,
          latest_alsfrs_score: item,
          participantName: item,
          date_of_onset: item,
          age: item,
          ethincity: item,
          email: item,
          phone: item,
          status: item,
          lastContacted: item,
          firstSessionDate: item,
          lastSessionDate: item,
          action: item,
          ambaserder_name: item,
          lastContactedBy: item,
          modalityId: item,
          referredBy: item,
          researchType: item,
          lastName: item,
          lastName: item,
          dateJoined: item,
          neurostampId: item,
          address: item,
          noOfSessions: item,
          relation_to_als: item,
          gender: item,
          date_of_diagnosis: item,
        };
      });
    const items = [
      {
        key: "1",
        label: "Synopsis",
        children: (
          <div className="accordion-content">
            <p>
              <Synopsis />
            </p>
          </div>
        ),
      },
    ];
    return (
      <div className="participant-activity-div">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-lg-10 participant-right-section-wrapper">
            <div className="inner-wrapper">
              <div className="row top-space">
                <div className="col-lg-1"></div>
                <div className="col-lg-11">
                  <div className="ambassador-heading-section mb-3">
                    <h3
                      style={{
                        position: "relative",
                        fontSize: 28,
                        fontFamily: "Open Sans",
                        fontWeight: "bold",
                        color: "#1A4F83",
                        textAlign: "start",
                      }}
                      className="mb-3"
                    >
                      {Strings.speechParticipants} - (
                      {this.state.type == "all" && "Total Participants"}
                      {this.state.type == "active" && "Active Participants"}
                      {this.state.type == "not_active" &&
                        "Withdrawn Participants"}
                      : {this.state.totalParticipantCount})
                    </h3>
                  </div>
                  <div className="synopsis-accordion">
                    <div className="row" style={{ padding: "2%" }}>
                      <Collapse
                        items={items}
                        defaultActiveKey={[]}
                        onChange={this.onChangeTab}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="all-participant-list">
                {/* background overlay  */}
                {this.state.needtoupgrade == true && (
                  <div className="background-overlay">
                    <div className="row">
                      <div className="col-lg-1"></div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11">
                        <div className="need-to-upgrade-wrapper">
                          <div className="inner-ui">
                            {/* <center>
                             <box-icon
                               name="smile"
                               size={"120px"}
                               color="#a6a6a6"
                             ></box-icon>
                           </center> */}
                            <h4>Upgrade to Platinum to access all data</h4>
                            <p>
                              Contact Christian Rubio{" "}
                              <a
                                style={{ color: "#007dfc" }}
                                href="mailto:christian@everythingals.org"
                              >
                                christian@everythingals.org
                              </a>{" "}
                              to learn more about Platinum membership and how to
                              upgrade
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="content">
                  <div className="row mb-3 align-items-center">
                    <div className="col-lg-1"></div>
                    <div className="col-12 col-sm-12 col-lg-2"></div>
                  </div>
                  <div
                    className="row mb-3"
                    style={{ display: "flex", justifyContent: "start" }}
                  >
                    <div className="col-lg-1"></div>
                    <div className="col-lg-3">
                      <label>Search</label>
                      <input
                        type="text"
                        className="form-control input-field filter-element mb-3"
                        value={this.state.searchVal}
                        placeholder="Search.."
                        onChange={(e) => {
                          this.setState({ searchVal: e.target.value }, this.debouncedFilter);
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-lg-3">
                      <label>Sort By</label>
                      <Select
                        defaultValue={this.state.sortBy}
                        style={{ width: "100%", marginRight: 8, fontSize: 16 }}
                        onChange={(v) => {
                          this.handleSortChange(v);
                          if (this.debouncedFilter) this.debouncedFilter();
                        }}
                        value={this.state.sortBy}
                        className="filter-element mb-3 filter-select-menu no-tag-select"
                        placeholder="Sort By"
                      >
                        <Option value="">Sort By</Option>
                        <Option value="LastContactedAsc">
                          Last Contacted Asc
                        </Option>
                        <Option value="LastContactedDesc">
                          Last Contacted Desc
                        </Option>
                        <Option value="LastActiveAsc">Last Session Asc</Option>
                        <Option value="LastActiveDesc">
                          Last Session Desc
                        </Option>
                      </Select>
                    </div>
                    <div className="col-lg-4 filter-by-column-input-wrapper">
                      <label>Filter By Column</label>
                      <Select
                        className="select-status participant-ac-column-filter-input mb-3"
                        mode="multiple"
                        style={{ width: "95%" }}
                        onChange={(v) => {
                          this.handleChangeColumns(v);
                          if (this.debouncedFilter) this.debouncedFilter();
                        }}
                        value={this.state.selectedColumns}
                        placeholder="Filter By Columns"
                        maxTagCount={1}
                        disabled={
                          this.state.columnChecked == true ? true : false
                        }
                      >
                        {PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS &&
                          PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS.map(
                            (item, index) => {
                              return (
                                <Option key={index} value={item}>
                                  {item}
                                </Option>
                              );
                            }
                          )}
                      </Select>
                    </div>
                  </div>
                  <div
                    className="row mb-3"
                    style={{ display: "flex", justifyContent: "start" }}
                  >
                    <div className="col-lg-1"></div>
                    <div className="col-lg-3 filter-by-activity-input-wrapper">
                      <label>Filter By Activity</label>
                      <Select
                        defaultValue={this.state.type}
                        onChange={(v) => {
                          this.handleChangeType(v);
                          if (this.debouncedFilter) this.debouncedFilter();
                        }}
                        value={this.state.type}
                        className="filter-element researchby-input filter-select-menu no-tag-select"
                        placeholder="Select Type"
                        style={{ fontSize: 16, width: "100%" }}
                      >
                        <Option value="all">All</Option>
                        <Option value="active">Active</Option>
                        <Option value="not_active">Withdrawn</Option>
                      </Select>
                    </div>
                    <div className="col-lg-3 filter-by-als-control-input-wrapper">
                      <label>Filter By ALS/Controls</label>
                      <Select
                        defaultValue={this.state.participantType}
                        onChange={(v) => {
                          this.handleChangeParticipantType(v);
                          if (this.debouncedFilter) this.debouncedFilter();
                        }}
                        value={this.state.participantType}
                        className="filter-element researchby-input filter-select-menu no-tag-select"
                        placeholder="Select Type"
                        style={{ fontSize: 16, width: "100%" }}
                      >
                        <Option value="all">All</Option>
                        <Option value="als">ALS</Option>
                        <Option value="controls">Controls</Option>
                      </Select>
                    </div>
                    <div className="col-lg-3 filter-by-status-input-wrapper">
                      <label>Filter By Status</label>
                      <Select
                        className="select-status filter-element mb-3 no-tag-select"
                        mode="tags"
                        defaultValue={this.state.selectedStatus}
                        style={{ width: "95%", marginRight: 8 }}
                        onChange={(v) => {
                          this.filterStatus(v);
                          if (this.debouncedFilter) this.debouncedFilter();
                        }}
                        value={this.state.selectedStatus}
                        placeholder="Filter By Status"
                      >
                        {this.state.type == "active" &&
                          ACTIVE_STATUS_LIST.map((item, index) => {
                            return (
                              <Option value={item} key={index}>
                                {item}
                              </Option>
                            );
                          })}
                        {this.state.type == "not_active" &&
                          NOT_ACTIVE_STATUS_LIST.map((item, index) => {
                            return (
                              <Option value={item} key={index}>
                                {item}
                              </Option>
                            );
                          })}
                        {this.state.type == "all" &&
                          ALL_STATUS_LIST.map((item, index) => {
                            return (
                              <Option value={item} key={index}>
                                {item}
                              </Option>
                            );
                          })}
                      </Select>
                    </div>
                  </div>
                  <div className="row participant-activity-table mt-5">
                    <div className="col-lg-1"></div>
                    <div className="col-lg-11">
                      <Table
                        dataSource={dataSource}
                        loading={this.state.tableloader}
                        columns={this.state.activeColumns}
                        pagination={{ pageSize: this.state.pagination }}
                        scroll={{
                          x:
                            this.state.isSingleColumn == true
                              ? 0
                              : localStorage.getItem("PHIStatus") == "true"
                              ? 1900
                              : 2000,
                        }}
                        onChange={this.handleTableChange}
                      />
                      <br />
                      {/* Start note section  */}
                      <SpeechNote />
                      {/* End note section  */}
                      <br />
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default List;
  